<xt-portal-stepper-dialog
  *transloco="let t"
  [currentStep]="currentStep"
  [stepCount]="stepCount"
  [stepHeader]="t('app.dialog.addDocument.consent')"
  [config]="dialogConfig"
  [contentTemplate]="content"
  [actionsTemplate]="actions"
>
  <ng-template #content>
    <div class="questionnaire-dialog-privacyPolicy">
      <span
        class="dialog-text"
        [innerHTML]="
          t('app.privacyCockpit.consentDialog.contentPartOne') +
          '<br/><br/>' +
          t('app.privacyCockpit.consentDialog.contentPartTwo') +
          link +
          ' ' +
          t('app.privacyCockpit.consentDialog.contentPartThree')
        "
      ></span>
      <span class="dialog-text">
        <a
          class="blue-link"
          [href]="consents().privacyPolicy"
          target="_blank"
          rel="noopener noreferrer"
          [xTentionDummyCypress]="'questionnaire-dialog.privacy-policy-link'"
        >
          {{ t('app.diary.privacyPolicy') }}
        </a>
        {{ t('app.diary.take') }}
      </span>
    </div>
  </ng-template>

  <ng-template #actions>
    <xt-portal-button
      [color]="'primary'"
      [width]="'large'"
      [text]="t('app.labels.cancel')"
      [textAlign]="'center'"
      [style]="'stroked'"
      [xTentionDummyCypress]="'questionnaire-dialog.steps.second.close'"
      (clickEvent)="closeDialog()"
    />
    <xt-portal-button
      [width]="'large'"
      [text]="t('app.actions.share')"
      [textAlign]="'center'"
      [xTentionDummyCypress]="
        'questionnaire-dialog.steps.second.share-questionnaire'
      "
      (clickEvent)="shareQuestionnaire()"
    />
  </ng-template>
</xt-portal-stepper-dialog>